module.exports = __webpack_public_path__ + "img/visualstudioicon.0ac005ed.png";